//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "NSFSummary",
    props: {
        resident: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            modalName: 'nsf-summary',
            allowedOverrideRoles: ['super-admin', 'corporate-admin', 'accounting-admin', 'regional-manager', 'property-manager'],
            overrideHistory: [],
            overrideAllowed: !!this.resident.n_s_f_payment_meta.override_allowed
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('close-full-modal', function (name) {
            if (name == _this.modalName) {
                Object.assign(_this.$data, _this.$options.data());
            }
        });

        Event.$on('override', function () {
            _this.changeOverrideStatus();
        });

        Event.$on('go-back', function () {
            _this.overrideAllowed = !_this.overrideAllowed;
        });

        Event.$on('nsf-summary', function () {
            Event.$emit('open-slide', _this.modalName);
        });

        Event.$on('change-override-status', function () {
            _this.changeOverrideStatus();
        });
    },

    methods: {
        cancel: function cancel() {
            Event.$emit('close-slide', this.modalName);
        },
        confirmOverride: function confirmOverride() {
            Event.$emit('cancel-notice');
        },
        changeOverrideStatus: function changeOverrideStatus() {
            var self = this;
            var sendData = {
                resident: self.resident.id,
                type: 'payment',
                reason: 'nsf-payment',
                override_allowed: Number(self.overrideAllowed)
            };

            window.axios.post('/prototype/person/resident/change-nsf-override', sendData).then(function (response) {
                self.$snotify.success(response.data.msg);
                self.resident = response.data.resident; //@TODO: shouldn't mutate the prop
            }).then(function (response) {
                Event.$emit("update-resident-detail");
            }).catch(function () {
                self.$snotify.error('Unable to change override.');
            });
        },
        canUserCanOverride: function canUserCanOverride() {
            return this.allowedOverrideRoles.includes(window.validator.role());
        }
    },
    watch: {
        resident: function resident(_resident, oldResident) {
            this.overrideHistory = JSON.parse(_resident.n_s_f_payment_meta.override_history);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/nsf/NSFSummary.vue
// module id = DK2h
// module chunks = 0 1